import React from 'react';
import Button from '../common/Button.js';
import { formatCurrencyShort } from '../../utils/amountHelpers.js';

const formatCurrency = formatCurrencyShort;

const formatNumber = (value) =>
  new Intl.NumberFormat('en-US').format(value || 0);

const formatDate = (date) => {
  if (!date) return 'N/A';
  const parsed = new Date(date);
  return Number.isNaN(parsed.getTime()) ? 'N/A' : parsed.toLocaleDateString();
};

const ProductTable = ({ products, loading, onViewDetails }) => (
  <section className="rounded-3xl border border-gray-200 bg-white p-6 shadow-sm">
    <div className="flex items-center justify-between gap-4 pb-4 border-b border-gray-200">
      <div>
        <h2 className="text-2xl font-semibold text-slate-900">Product catalog</h2>
        <p className="text-sm text-gray-500">Browse all products and open details for inventory and trend insights.</p>
      </div>
      <div className="text-sm text-gray-500">
        {loading ? 'Loading products…' : `${products.length} product${products.length === 1 ? '' : 's'} listed`}
      </div>
    </div>

    <div className="mt-6 h-[400px] overflow-auto">
      <table className="min-w-[900px] divide-y divide-gray-200 text-sm">
        <thead className="bg-gray-50 text-left text-gray-600">
          <tr>
            <th className="px-4 py-3 font-medium">Product</th>
            <th className="px-4 py-3 font-medium">Branch</th>
            <th className="px-4 py-3 font-medium">Category</th>
            <th className="px-4 py-3 font-medium">Sold</th>
            <th className="px-4 py-3 font-medium">Revenue</th>
            <th className="px-4 py-3 font-medium">Discount</th>
            <th className="px-4 py-3 font-medium">Last sold</th>
            <th className="px-4 py-3 font-medium text-center">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {products.length === 0 && (
            <tr>
              <td colSpan="8" className="px-4 py-8 text-center text-gray-500">
                {loading ? 'Loading products, please wait...' : 'No products match the current filters.'}
              </td>
            </tr>
          )}

          {products.map((product) => (
            <tr key={product.id} className="hover:bg-gray-50">
              <td className="px-4 py-4">
                <div className="flex items-center gap-3">
                  {product.image && (
                    <img src={product.image} alt={product.name} className="h-10 w-10 rounded-lg object-cover" />
                  )}
                  <div className="min-w-0">
                    <div className="truncate font-medium text-slate-900">{product.name}</div>
                  </div>
                </div>
              </td>
              <td className="px-4 py-4 text-gray-600 whitespace-nowrap">{product.branchName || 'All branches'}</td>
              <td className="px-4 py-4 text-gray-600 whitespace-nowrap">{product.category || 'Uncategorized'}</td>
              <td className="px-4 py-4 text-gray-900 whitespace-nowrap">{formatNumber(product.totalOrders)}</td>
              <td className="px-4 py-4 text-gray-900 whitespace-nowrap">{formatCurrency(product.totalRevenue)}</td>
              <td className="px-4 py-4 text-gray-900 whitespace-nowrap">{formatCurrency(product.totalDiscount || 0)}</td>
              <td className="px-4 py-4 text-gray-600 whitespace-nowrap">{formatDate(product.lastSoldAt)}</td>
              <td className="px-4 py-4 text-right">
                <Button variant="secondary" size="small" onClick={() => onViewDetails(product)}>
                  View more
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);

export default ProductTable;
